export const STAY_IN_TOUCH = 'footer';
export const CHECKOUT = 'checkout';

export const cookieReminderClose = 'CUSTOMER_REMINDER_CLOSE';
export const cookieActiveSubscription = 'activeSubscription';

export const RESPONSE_SUBSCRIBE_FORM = {
    SUCCESS: 0,
    ALREADY: 3,
    ERROR: 2,
};
